import * as actions from '../actions/constants';
import { channelObjects } from '../../../shared/model/constants/channels';

// Always reset value for a list of channels
const resetForChannel = (channels, currentChannel, value) => {
  // Channel is in the channel array
  const shouldReset = channels.indexOf(currentChannel) !== -1;

  return shouldReset ? undefined : value;
};

// Set a value to undefined when moving between channels
const resetInEitherChannel = (channels, fromChannel, nextChannel, value) => {
  // From channel is in the from array
  const matchedFromChannel = channels.indexOf(fromChannel) !== -1;

  // Next channel is in the next array
  const matchedNextChannel = channels.indexOf(nextChannel) !== -1;

  // If either match, reset the value
  return matchedFromChannel || matchedNextChannel ? undefined : value;
};

export default function channelReducer(state = {}, action) {
  const nextChannel = action.value;
  const fromChannel = state.channel;

  switch (action.type) {
    case actions.UPDATE_CHANNEL:
      return {
        ...state,
        channel: nextChannel,
        minPrice: resetInEitherChannel([channelObjects.ForLease.url, channelObjects.Leased.url], fromChannel, nextChannel, state.minPrice),
        maxPrice: resetInEitherChannel([channelObjects.ForLease.url, channelObjects.Leased.url], fromChannel, nextChannel, state.maxPrice),
        tenureType: resetForChannel([channelObjects.ForLease.url, channelObjects.Invest.url, channelObjects.Leased.url], nextChannel, state.tenureType),
        tenureTypeKey: resetForChannel([channelObjects.ForLease.url, channelObjects.Invest.url, channelObjects.Leased.url], nextChannel, state.tenureTypeKey),
        energyEfficiency: resetForChannel([channelObjects.Invest.url], nextChannel, state.energyEfficiency),
        numParkingSpaces: resetForChannel([channelObjects.Invest.url], nextChannel, state.numParkingSpaces),
      };
    default:
      return state;
  }
}
